import React, { useEffect, createContext, useMemo } from 'react';
import { Prompt } from 'react-router';
var DEFAULT_MESSAGE = 'Changes you made may not be saved.';
var DEFAULT_CONTEXT = {
  message: DEFAULT_MESSAGE,
  when: false
};
export var NavigationPromptContext = createContext(DEFAULT_CONTEXT);
export default function NavigationPrompt(_ref) {
  var _ref$message = _ref.message,
    message = _ref$message === void 0 ? DEFAULT_MESSAGE : _ref$message,
    when = _ref.when,
    children = _ref.children;
  var context = useMemo(function () {
    return {
      when: when,
      message: message
    };
  }, [message, when]);

  // some inspiration from this gist: https://gist.github.com/sibelius/60a4e11da1f826b8d60dc3975a1ac805
  // and MDN: https://developer.mozilla.org/en-US/docs/Web/API/BeforeUnloadEvent#Examples
  useEffect(function () {
    var handler = function handler(e) {
      if (when) {
        e.preventDefault();
        e.returnValue = message;
        return message;
      }
    };
    window.addEventListener('beforeunload', handler, false);
    return function () {
      return window.removeEventListener('beforeunload', handler);
    };
  }, [when, message]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(NavigationPromptContext.Provider, {
    value: context
  }, children), when ? /*#__PURE__*/React.createElement(Prompt, {
    message: message
  }) : null);
}